import {
    useFormAddonGroup,
    useFormUnregisterField,
} from '@/features/pos/components/ProductConfigurationModal/form'
import { FormKeys } from '@/features/pos/components/ProductConfigurationModal/form/constants'
import { useUpdateRepeatableAddon } from '@/features/pos/components/ProductConfigurationModal/parts/AddonGroup/hooks/useUpdateRepeatableAddon'
import MultiOptionItem from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/Multi'
import { AddonGroup } from '@/features/pos/components/ProductConfigurationModal/types'
import { FC } from 'react'

interface RepeatableAddonListProps {
    addonGroup: AddonGroup
}

const RepeatableAddonList: FC<RepeatableAddonListProps> = ({ addonGroup }) => {
    const [formAddonGroup, onChange] = useFormAddonGroup(addonGroup)

    useFormUnregisterField(`${FormKeys.AddonGroups}.${addonGroup.id}`)

    const updateAddon = useUpdateRepeatableAddon(addonGroup, formAddonGroup, onChange)

    return (
        <>
            {addonGroup.addons.map((addon) => (
                <MultiOptionItem
                    key={addon.id}
                    id={addon.id}
                    disabled={addon.soldOut}
                    quantity={formAddonGroup?.addonQuantities[addon.id] ?? 0}
                    name={addon.name}
                    price={addon.price}
                    onQuantityChange={updateAddon}
                />
            ))}
        </>
    )
}

export default RepeatableAddonList
